import { getBackendUrl } from "api/common";
import axios from "axios";

interface PuzzelSettings {
  clientId: string;
  idpScheme?: string;
  ciqType: string;
  phoneNumberPrefix: string;
  functionalNumberPrefix: string;
  countryCode: string;
  maxAttempts: number;
  maxOneRequestForPreferredAgent: boolean;
  preferredAgentWaitTimeSeconds: number;
  queueKey: string;
  reservedAgentWaitTimeSeconds: number;
  secondsBetweenAttempts: number;
}

interface CognitoSettings {
  authUrl: string;
  clientId: string;
  userPoolId: string;
}

interface AppData {
  authUrl: string;
  clientId: string;
  userPoolId: string;
  puzzelClientId: string;
  puzzelIdpScheme?: string;
  puzzelCiqType: string;
  puzzelPhoneNumberPrefix: string;
  puzzelFunctionalNumberPrefix: string;
  puzzelCountryCode: string;
  puzzelMaxAttempts: number;
  puzzelMaxOneRequestForPreferredAgent: boolean;
  puzzelPreferredAgentWaitTimeSeconds: number;
  puzzelQueueKey: string;
  puzzelReservedAgentWaitTimeSeconds: number;
  puzzelSecondsBetweenAttempts: number;
  cognitoSettings: CognitoSettings | null;
  puzzelSettings: PuzzelSettings | null;
}

export const getAppData = async (): Promise<AppData> => {
  const response = await axios.get<AppData>(`${getBackendUrl()}/app-data`);
  return response.data;
};
